import React from 'react'
import { Parallax } from 'react-parallax'
import {
  CFView,
  CFText,
  CFImage,
  CFLink,
  DefaultScreen,
  MobileScreen,
} from 'components'
import Header from './Header'
import OrderPickupButton from './OrderPickupButton'
import { hero, heroText, mobileHero } from 'images'

export default () => {
  return (
    <CFView>
      <MobileScreen>
        <CFView
          image={`url(${mobileHero}) 0 75% / cover no-repeat`}
          w="100%"
          h="95VH"
          alt="Hero"
          column
          justifyBetween
          alignCenter
        >
          <CFImage src={heroText} alt="Logo" w="95%" mv="10px" />
          <CFView mb="30px" pulsate column center>
            <OrderPickupButton />
          </CFView>
        </CFView>
      </MobileScreen>
      <DefaultScreen>
        <CFView w="100%" zIndex={90} column center textCenter>
          <CFView
            image={`url(${hero}) center / cover no-repeat`}
            w="100%"
            alt="Hero"
            h="600px"
            column
            justifyBetween
            alignCenter
          >
            <CFImage src={heroText} alt="Logo" w="450px" mv="10px" />
            <CFView row center mb="45px">
              <CFView pulsate>
                <OrderPickupButton />
              </CFView>
            </CFView>
          </CFView>
        </CFView>
      </DefaultScreen>
    </CFView>
  )
}
